import { useEffect, useState } from "react";
import { Wallet } from "lucide-react";
import { PageHeader, Spinner, Card } from "@/components/dash";
import CoinIcon from "@/components/CoinIcon";
import api from "@/lib/api";
import { formatTRY, formatCrypto } from "@/lib/format";

export default function WalletPage() {
  const [balances, setBalances] = useState(null);
  useEffect(() => { api.get("/wallet").then(({ data }) => setBalances(data.balances)).catch(() => setBalances([])); }, []);

  if (!balances) return <Spinner />;
  const totalTry = balances.reduce((a, b) => a + (b.available * (b.rate_try || 0)), 0);

  return (
    <div>
      <PageHeader title="Cüzdan" desc="Kripto bakiyelerinizi coin bazında görüntüleyin." />

      <Card className="p-6 mb-6 bg-primary text-white border-primary">
        <p className="text-sm text-white/70">Toplam Kullanılabilir Bakiye (yaklaşık)</p>
        <p className="mt-1 text-3xl font-extrabold tracking-tighter" data-testid="wallet-total">{formatTRY(totalTry)}</p>
      </Card>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="wallet-balances">
        {balances.map((b) => (
          <Card key={b.coin} className="p-5">
            <div className="flex items-center gap-3">
              <CoinIcon symbol={b.coin} size={38} />
              <div>
                <p className="font-bold">{b.coin}</p>
                <p className="text-xs text-muted-foreground">1 {b.coin} ≈ {formatTRY(b.rate_try)}</p>
              </div>
            </div>
            <div className="mt-4 space-y-2 text-sm">
              <Row l="Kullanılabilir" r={formatCrypto(b.available, b.coin)} bold />
              <Row l="Bekleyen" r={formatCrypto(b.pending, b.coin)} />
              <Row l="Toplam Alınan" r={formatCrypto(b.total_received, b.coin)} />
              <Row l="Toplam Çekilen" r={formatCrypto(b.total_withdrawn, b.coin)} />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

function Row({ l, r, bold }) {
  return (
    <div className="flex justify-between">
      <span className="text-muted-foreground">{l}</span>
      <span className={bold ? "font-bold" : "font-medium"}>{r}</span>
    </div>
  );
}
